import { Swiper, SwiperSlide } from 'swiper/react';
import SubVisual from '../../../components/SubVisual';
import useFaq from './hook/useFaq';
import { useSearchParams } from 'react-router';
import { Navigation, Pagination } from 'swiper/modules';
import { useMemo } from 'react';

const maxButtons = 10;

const FaqPage = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { faqInfo, faqKeyUpSearch, faqClickSearch, changeCate, searchValue, setSearchValue, goToDetail } = useFaq();

	const startPage = useMemo(
		() => Math.floor(((faqInfo?.currentPage || 0) - 1) / maxButtons) * maxButtons + 1,
		[faqInfo]
	);
	const endPage = useMemo(() => Math.min(startPage + maxButtons - 1, faqInfo?.totalPage || 0), [faqInfo]);

	const pages = useMemo(() => {
		if (!faqInfo) return [];
		const arr = [];
		for (let i = startPage; i <= endPage; i++) {
			arr.push(i);
		}
		return arr;
	}, [faqInfo, startPage, endPage]);

	return (
		<main id="sub" className="sub faq">
			<SubVisual cate={''} title={'자주 묻는 질문'} />

			<section id="" className="sub-content">
				<div className="sub-inner">
					<div className="faq-best">
						<div className="faq-best-inner">
							<strong className="faq-best-title">자주 묻는 질문 BEST</strong>
							<div className="faq-best-swiper">
								<div className="swiper-wrapper"></div>
							</div>
							<div className="swiper-controll">
								<div className="best-item swiper-button-next"></div>
								<div className="best-item swiper-pagination"></div>
							</div>
						</div>
					</div>

					{/* 탭 버튼 */}
					<div className="sub-tab">
						<Swiper
							modules={[Pagination, Navigation]}
							spaceBetween={16}
							watchOverflow={false}
							slidesPerView="auto"
							navigation={{
								nextEl: '.swiper-nav .swiper-button-next',
								prevEl: '.swiper-nav .swiper-button-prev'
							}}
							observer={true}
							observeParents={true}>
							<SwiperSlide>
								<button
									key={'all'}
									type="button"
									className={`tab-btn ${!searchParams.get('cate') ? 'active' : ''}`}
									onClick={() => changeCate('')}>
									전체
								</button>
							</SwiperSlide>
							{faqInfo?.faqCtgryList.map((item, idx) => (
								<SwiperSlide key={idx}>
									<button
										key={idx}
										type="button"
										className={`tab-btn ${searchParams.get('cate') === item.faqCtgryNm ? 'active' : ''}`}
										onClick={() => changeCate(item.faqCtgryNm)}>
										{item.faqCtgryNm}
									</button>
								</SwiperSlide>
							))}
						</Swiper>
						<div className="swiper-nav">
							<div className="swiper-button-prev"></div>
							<div className="swiper-button-next"></div>
						</div>
					</div>

					{/* 검색 */}
					<div className="search-bar">
						<input
							type="text"
							placeholder="검색어를 입력하세요"
							autoComplete="off"
							value={searchValue}
							onChange={e => setSearchValue(e.target.value)}
							onKeyUp={faqKeyUpSearch}
						/>
						<button type="button" className="btn-search" onClick={faqClickSearch}></button>
					</div>

					{/* FAQ 리스트 */}
					<div className="board-wrap">
						<ul className="board-list faq">
							{faqInfo?.list?.map(item => (
								<li key={item.faqId} onClick={() => goToDetail(item.faqId, item.faqCtgryId)}>
									<a>{item.faqTitl}</a>
								</li>
							))}
						</ul>

						{/* 페이지네이션은 별도 컴포넌트로 분리 권장 */}
						<div className="board-pagination">
							<button
								className="pagination-btn btn-prev"
								disabled={faqInfo?.currentPage === 1}
								onClick={() =>
									setSearchParams(prev => {
										prev.set('page', ((faqInfo?.currentPage || 0) - 1).toString());
										return prev;
									})
								}></button>

							{pages.map(page => (
								<button
									key={page}
									className={`pagination-btn ${faqInfo?.currentPage === page ? 'active' : ''}`}
									onClick={() =>
										setSearchParams(prev => {
											prev.set('page', page.toString());
											return prev;
										})
									}>
									{page}
								</button>
							))}

							<button
								className="pagination-btn btn-next"
								disabled={faqInfo?.currentPage === faqInfo?.totalPage}
								onClick={() =>
									setSearchParams(prev => {
										prev.set('page', ((faqInfo?.currentPage || 0) + 1).toString());
										return prev;
									})
								}></button>
						</div>
					</div>
				</div>
			</section>
		</main>
	);
};

export default FaqPage;
